module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- Transfer Date -->\n';
 if ( pending ) { ;
__p += '\n  <div id="changegroup-status" class="alert alert-danger" role="alert">\n    <span class="glyphicon glyphicon-exclamation-sign"></span> בקשה זו טרם אושרה. היא הוגשה לועדת הכספים\n';
 } else { ;
__p += '\n  <div id="changegroup-status" class="approved">\n    משרד האוצר דיווח שבקשה זו אושרה\n';
 } ;
__p += '\n    ב-\n' +
((__t = ( date )) == null ? '' : __t) +
'\n</div>\n\n<!-- Analyzed Title -->\n';
 if ( title_template === "cutbacks-expense" ) { ;
__p += '\n  <h1 class="decreased">\n    הפחתה של ' +
((__t = ( format_number( title_value ) )) == null ? '' : __t) +
' בתקציב ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "enlargement-expense" ) { ;
__p += '\n  <h1 class="increased">\n    הגדלה של ' +
((__t = ( format_number( title_value ) )) == null ? '' : __t) +
' בתקציב ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "cutbacks-commitment" ) { ;
__p += '\n  <h1 class="decreased">\n    הפחתה של ' +
((__t = ( format_number( title_value ) )) == null ? '' : __t) +
' בהרשאה להתחייב של ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "enlargement-commitment" ) { ;
__p += '\n  <h1 class="increased">\n    הגדלה של ' +
((__t = ( format_number( title_value ) )) == null ? '' : __t) +
' בהרשאה להתחייב של ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "cutbacks-personnel" ) { ;
__p += '\n  <h1 class="decreased">\n    הפחתה של ' +
((__t = ( title_value )) == null ? '' : __t) +
' בתקני כח האדם של ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "enlargement-personnel" ) { ;
__p += '\n  <h1 class="increased">\n    הגדלה של ' +
((__t = ( title_value )) == null ? '' : __t) +
' בתקני כח האדם של ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "internal-change" ) { ;
__p += '\n  <h1>\n    שינוי פנימי של ' +
((__t = ( title_value )) == null ? '' : __t) +
' בתקציב ' +
((__t = ( titles[0] )) == null ? '' : __t) +
'\n';
 } else if ( title_template === "transfer-expenses" ) { ;
__p += '\n  <h1>\n    העברה של ' +
((__t = ( format_number( title_value ) )) == null ? '' : __t) +
' מתקציב ' +
((__t = ( titles[0].join(", ") )) == null ? '' : __t) +
' לתקציב ' +
((__t = ( titles[1].join(", ") )) == null ? '' : __t) +
'\n';
 } ;
__p += '\n</h1>\n\n<!-- Original Titles -->\n<ul>\n    <li>\n        מספרי פניה: ' +
((__t = ( committee_ids.join(", ") )) == null ? '' : __t) +
'\n    </li>\n    <li>\n        בקשות: ' +
((__t = ( transfer_ids.join(", ") )) == null ? '' : __t) +
'\n    </li>\n</ul>\n<div id="changegroup-request">\n  <h4>- דברי הסבר -</h4>\n  <h3>הנדון:\n ' +
((__t = ( _.uniq(req_titles).join(" / ") )) == null ? '' : __t) +
'\n  </h3>\n\n  <p>' +
((__t = ( explanation.replace(/\n/g,'<br/>') )) == null ? '' : __t) +
'</p>\n</div>\n\n<h4>סעיפים משתתפים</h4>\n<!-- Transfer Details -->\n';
 var prev_len = 2; ;
__p += '\n';
 for ( var _change in changes ) { var change = changes[_change]; if ( _change == 0 ) { continue; } ;
__p += '\n    ';
 for ( var i = prev_len ; i > change.budget_code.length; i-=2 ) { ;
__p += '\n        </ul>\n    ';
 } ;
__p += '\n    ';
 for ( var i = prev_len ; i < change.budget_code.length; i+=2 ) { ;
__p += '\n        <ul>\n    ';
 } ;
__p += '\n    <li>\n        <a href="' +
((__t = ( window.URLSchemeHandlerInstance.linkToBudget(change.budget_code,year))) == null ? '' : __t) +
'">' +
((__t = ( change.budget_code.slice(2) )) == null ? '' : __t) +
' - ' +
((__t = ( change.budget_title )) == null ? '' : __t) +
'</a>\n        <ul>\n            <li>שינוי בתקציב הוצאות: ' +
((__t = ( format_number( change.expense_change ) )) == null ? '' : __t) +
'</li>\n            <li>שינוי בהרשאה להתחייב: ' +
((__t = ( format_number( change.commitment_change ) )) == null ? '' : __t) +
'</li>\n            <li>שינוי בתקני כח אדם: ' +
((__t = ( change.personnel_change )) == null ? '' : __t) +
'</li>\n        </ul>\n    </li>\n    ';
 prev_len = change.budget_code.length; ;
__p += '\n';
 } ;
__p += '\n</ul>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/single-changegroup.html
// module id = 141
// module chunks = 0